import { Tooltip, Icon, colors } from '@dev-spendesk/grapes';
import { type PublishedPayableRule } from '@spendesk/bookkeeping-core-types';

import type {
  AnalyticalFieldAssociationAutomation,
  ExpenseAccountAutomation,
  VatAccountAutomation,
} from '../..';
import type { TGlobalFunctionTyped } from '../../../../common/hooks/useTranslation';
import { ruleBasedAutomationTooltipContent } from '../../helpers/rule-based-automation';

export const AutomationIcon = ({
  automation,
  rule,
  t,
}: {
  automation?:
    | AnalyticalFieldAssociationAutomation
    | ExpenseAccountAutomation
    | VatAccountAutomation;
  rule?: PublishedPayableRule;
  t: TGlobalFunctionTyped;
}) => {
  if (!automation?.kind) {
    return null;
  }

  if (automation.kind === 'ruleBased') {
    return rule ? (
      <Tooltip
        content={ruleBasedAutomationTooltipContent(rule, t)}
        triggerAsChild
      >
        <Icon
          data-testid="automation-icon"
          color={colors.contentDecorativeIcon}
          name="lightning"
        />
      </Tooltip>
    ) : null;
  }

  // TODO: change translation key if used by nonRuleBased automations
  return (
    <Tooltip
      content={t(
        'expenseInbox.expenseEditor.analyticalFieldAssociationPrefilledByPrediction',
      )}
      triggerAsChild
    >
      <Icon
        data-testid="automation-icon"
        color={colors.contentBrandDefault}
        name="sparkle"
      />
    </Tooltip>
  );
};
